export default {
  title: 'Bestelgegevens',
};
